<template>
  <v-dialog v-model="dialog" persistent width="780px">
    <v-card>
      <v-card-title class="headline">
        <v-icon>edit</v-icon> Modificar permiso
        <v-spacer></v-spacer>
        <v-btn icon @click="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-form @submit.prevent="save" v-model="valid" ref="form" lazy-validation>
        <v-card-text class="py-0 px-3">
          <v-container grid-list-md class="pa-0" style="min-width: 100%;">
            <v-layout row wrap>
              <v-flex xs12>
                <p>
                  Tipo de permiso: <strong>{{ permiso.tipo_permiso }}</strong>
                </p>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex md4 v-if="permiso.compensa_tolerancia != 0">
                <p>
                  <strong>Total horas a compensar:</strong>
                  {{ debe_horas_compensacion }}
                </p>
              </v-flex>
            </v-layout>

            <v-layout row wrap>
              <v-flex xs12>
                <v-textarea
                  class="text-field-reducido-border"
                  outline
                  label="Motivo"
                  type="text"
                  :rules="$validate(['required'])"
                  maxlength="500"
                  required
                  rows="2"
                  v-model="permiso.motivo"
                />
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  class="text-field-reducido-border"
                  outline
                  type="date"
                  v-model="permiso.fecha_desde"
                  label="Fecha"
                  :rules="$validate(['required'])"
                  required
                  @input="borrarLocalmente()"
                />
              </v-flex>
            </v-layout>

            <v-layout>
              <v-flex xs12 md6>
                <v-text-field
                  class="text-field-reducido-border"
                  outline
                  type="time"
                  label="Hora desde"
                  :rules="$validate(['required'])"
                  v-model="permiso.hora_desde"
                  @input="
                    borrarLocalmente() &&
                      obtieneHorasCompensacion() &&
                      verificarRangoMediaHora(true)
                  "
                  @change="borrarLocalmente() && verificarRangoMediaHora(false)"
                />
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  class="text-field-reducido-border"
                  outline
                  type="time"
                  label="Hora hasta"
                  :rules="$validate(['required'])"
                  v-model="permiso.hora_hasta"
                  @input="
                    borrarLocalmente() &&
                      obtieneHorasCompensacion() &&
                      verificarRangoMediaHora(true)
                  "
                  @change="borrarLocalmente() && verificarRangoMediaHora(false)"
                />
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex md12>
                <v-radio-group
                  v-model="radio_data"
                  row
                  :rules="[
                    v => {
                      if (v == null) return 'El campo es obligatorio.';
                      return true;
                    }
                  ]"
                >
                  <v-flex xs6>
                    <v-radio label="Compensación" :value="1"></v-radio>
                  </v-flex>
                  <v-flex xs6>
                    <v-radio label="Sin compensación" :value="0"></v-radio>
                  </v-flex>
                </v-radio-group>
              </v-flex>
            </v-layout>
            <!-- ARCHIVOS -->

            <v-layout>
              <v-flex>
                <!-- Eliminar archivo -->
                <v-btn
                  color="red"
                  @click.prevent="eliminarArchivo()"
                  icon
                  title="Eliminar archivo"
                >
                  <v-icon>clear</v-icon>
                </v-btn>
              </v-flex>
              <!-- Label nombre respaldo del archivo -->
              <v-flex>
                <p v-if="ruta_a && bandera_file == false">
                  <strong>Respaldo: </strong> {{ ruta_a }}
                </p>
                <p v-if="bandera_file == true">
                  <strong>Respaldo: </strong> Sin documento de Respaldo
                </p>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex>
                <input
                  type="file"
                  @change="handleFileUpload()"
                  ref="file"
                  color="primary"
                  dark
                />
                <p class="red--text body-1" v-if="errors.denied">
                  *Formato no admitido por el sistema
                </p>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions class="pr-4">
          <v-spacer></v-spacer>

          <v-btn
            @click.native="close()"
            color="red"
            v-if="radio_data == 0"
            dark
          >
            <v-icon>cancel</v-icon>CERRAR
          </v-btn>
          <v-btn
            @click.native="save()"
            color="green"
            dark
            v-if="
              radio_data == 0 &&
                permiso.motivo &&
                permiso.fecha_desde &&
                permiso.hora_desde &&
                permiso.hora_hasta &&
                bandera_media_hora == true
            "
          >
            <v-icon>check</v-icon>GUARDAR
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
    <v-card v-if="radio_data != 0">
      <v-card-title class="headline">
        <v-icon>edit</v-icon> Compensar permiso
        <v-spacer></v-spacer>
        {{
          horas_disponibles === null
            ? ""
            : `Tiene ${horas_disponibles} horas disponibles`
        }}
      </v-card-title>
      <v-form @submit.prevent="adicionarDetalle()" ref="form" lazy-validation>
        <v-card-text class="pt-0">
          <v-container grid-list-md class="pt-0">
            <v-layout>
              <v-flex md4>
                <p>
                  <strong>Total horas a compensar:</strong>
                  {{ debe_horas_compensacion }}
                </p>
              </v-flex>
            </v-layout>
            <!-- Fecha compensacion -->
            <v-layout>
              <v-flex md4>
                <v-text-field
                  type="date"
                  v-model="form.fecha_desde"
                  label="Fecha"
                  :rules="$validate(['required'])"
                  required
                  @input="verificaCompensacion()"
                />
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex md6>
                <v-radio-group
                  v-model="form.tipo_dia"
                  @change="verificaCompensacion()"
                >
                  <!-- <v-flex>
                    <v-radio label="Mañana" value="1"></v-radio>
                  </v-flex> -->
                  <v-flex>
                    <v-radio label="Tarde" value="2"></v-radio>
                  </v-flex>
                </v-radio-group>
              </v-flex>
              <v-flex md6>
                <v-radio-group
                  v-model="form.horario"
                  @change="verificaCompensacion()"
                >
                  <!-- <v-radio label="Ingreso" value="1"></v-radio> -->
                  <v-radio label="Salida" value="2"></v-radio>
                </v-radio-group>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex md4>
                <v-select
                  value="hora"
                  :items="rango_horarios"
                  type="hour"
                  item-value="hora"
                  item-text="hora"
                  label="Cantidad de horas"
                  v-model="form.horas_compensa"
                  autofocus
                  :rules="$validate(['required'])"
                  required
                  @input="verificaCompensacion()"
                ></v-select>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex md4>
                <v-text-field
                  type="time"
                  label="Hora desde"
                  v-model="hora_desde_calculada"
                  disabled
                />
              </v-flex>
              <v-flex md4>
                <v-text-field
                  type="time"
                  label="Hora hasta"
                  v-model="hora_hasta_calculada"
                  disabled
                />
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex md6>
                <v-spacer></v-spacer>
                <v-btn color="success" @click="cargarCompensacion()">
                  <v-icon>arrow_downward</v-icon>
                  Registrar
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-text>
          <v-container>
            <h3><strong>Detalles compensacion</strong></h3>
            <v-layout>
              <v-flex xs12>
                <v-data-table
                  class="tabla-comprimida-light elevation-1"
                  :items="compensaciones"
                  hide-actions
                  :headers="headers"
                >
                  <template v-slot:items="props">
                    <td class="text-xs-center">
                      {{ $moment(props.item.fecha_desde).format("DD/MM/YYYY") }}
                    </td>
                    <td class="text-xs-center">{{ props.item.hora_desde }}</td>
                    <td class="text-xs-center">{{ props.item.hora_hasta }}</td>
                    <td class="text-xs-center">
                      {{ props.item.total_horas }}
                    </td>
                    <td class="text-xs-center">
                      <v-btn
                        color="error"
                        icon
                        title="Eliminar compensacion"
                        @click="borrarCompensacionDetalle(props.item.id)"
                      >
                        <v-icon>delete</v-icon>
                      </v-btn>
                    </td>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
            <v-layout class="pa-2">
              <v-flex xs12>
                <h4>
                  <strong
                    >Total horas:
                    {{ total_horas_compensacion.format("HH:mm") }}</strong
                  >
                </h4>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions class="pr-4">
          <v-spacer></v-spacer>

          <v-btn @click.native="close()" color="red" dark>
            <v-icon>cancel</v-icon>CERRAR
          </v-btn>
          <v-btn
            @click.native="save()"
            color="green"
            dark
            v-if="
              this.permiso.motivo &&
                bandera_media_hora == true &&
                permiso.fecha_desde &&
                permiso.hora_desde &&
                permiso.hora_hasta
            "
          >
            <v-icon>check</v-icon>GUARDAR
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate";

export default {
  mixins: [validate],

  mounted() {
    this.$bus.$on(
      "openDialogModificarPermisoToleranciaCompensacion",
      async item => {
        this.permiso = item;
        if (this.permiso.permiso.ruta_archivo) {
          this.ruta_a = this.permiso.permiso.ruta_archivo;
        } else {
          this.ruta_a = "";
        }
        //
        if (this.permiso.compensa_tolerancia == 0) {
          this.radio_data = 0;
        } else {
          this.radio_data = 1;
        }

        this.permiso.fecha_desde = this.permiso.fecha_desde
          .split("/")
          .reverse()
          .join("-");
        this.fecha_desde_guardado = this.permiso.fecha_desde;
        this.hora_desde_guardado = this.permiso.hora_desde;
        this.hora_hasta_guardado = this.permiso.hora_hasta;
        this.id_permi = item.id_tipo_permiso;
        this.per_hora_desde = item.hora_desde;
        this.permi_lugar = item.permiso.lugar;
        this.permi_motivo = item.permiso.motivo;
        this.permiso.motivo = this.permiso.permiso.motivo;
        this.dialog = true;
        this.obtieneHorasCompensacion();
        await this.listCompensaciones();
      }
    );
  },
  data() {
    return {
      total_horas_resguardo: this.$moment().set({
        hour: 0,
        minutes: 0,
        seconds: 0
      }),
      errors: {
        denied: false
      },
      bandera_media_hora: true,
      radio_data: "",
      compensaciones_resguardo: [],
      fecha_desde_guardado: null,
      hora_desde_guardado: null,
      hora_hasta_guardado: null,
      bandera_borrado: false,
      debe_horas_compensacion: 0,
      dias_de_incapacidad: 0,
      nro_de_dias: 0,
      bandera_file: false,
      dias: 0,
      id_permi: "",
      ruta_a: "",
      file: "",
      dialog: false,
      edit: true,
      dias_habiles: 0,
      permiso: {
        id_tipo_permiso: null,
        motivo: "",
        permi_fecha_hasta: "",
        permi_fecha_desde: ""
      },
      permisos: [],
      tipo_permisos: [],
      permiso_detalle: {},
      valid: false,
      loading: false,

      horas_disponibles: null,
      hora_desde_calculada: "",
      hora_hasta_calculada: "",
      total_horas_calculada: "",
      mensaje_error: "",
      bandera_compensacion: false,
      correlativo_compensacion: 0,
      total_horas_compensacion: this.$moment().set({
        hour: 0,
        minutes: 0,
        seconds: 0
      }),
      form: {},
      rango_horarios: [
        {
          hora: "00:30"
        },
        {
          hora: "01:00"
        },
        {
          hora: "01:30"
        },
        {
          hora: "02:00"
        },
        {
          hora: "02:30"
        },
        {
          hora: "03:00"
        },
        {
          hora: "03:30"
        },
        {
          hora: "04:00"
        },
        {
          hora: "04:30"
        },
        {
          hora: "05:00"
        },
        {
          hora: "05:30"
        }
      ],
      compensaciones: [],

      headers: [
        {
          text: "Fecha",
          align: "center",
          sortable: false
        },
        {
          text: "Hora desde",
          align: "center",
          sortable: false
        },
        {
          text: "Hora hasta",
          align: "center",
          sortable: false
        },
        {
          text: "Total Horas",
          align: "center",
          sortable: false
        },
        {
          text: "Acción",
          align: "center",
          sortable: false
        }
      ],
      permiso_detalles: [],
      permisoDetalle: []
    };
  },

  methods: {
    async eliminarArchivo() {
      this.$refs.file.value = "";
      this.file = "";
      this.permiso.permiso.ruta_archivo = "";
      this.ruta_a = "";
      this.bandera_file = true;
    },
    handleFileUpload() {
      if (this.$refs.file.value !== "") {
        const file2 = this.$refs.file.files[0];
        if (this.$refs.file.files[0].type.includes("application/pdf")) {
          this.errors.denied = false;
        } else {
          this.errors.denied = true;
        }

        this.bandera_file = false;
        this.file = file2;
      }
    },
    async borrarLocalmente() {
      if (
        this.fecha_desde_guardado == this.permiso.fecha_desde &&
        this.hora_desde_guardado == this.permiso.hora_desde &&
        this.hora_hasta_guardado == this.permiso.hora_hasta
      ) {
        this.bandera_borrado = false;
        await this.listCompensaciones();
      } else {
        this.compensaciones = [];
        this.bandera_borrado = true;
        this.total_horas_compensacion = this.$moment().set({
          hour: 0,
          minutes: 0,
          seconds: 0
        });
      }
    },
    async listCompensaciones() {
      try {
        // SELECT * FROM CONTROL.permiso_compensacion  WHERE id_permiso = 220539
        let respuesta = await this.$service.graphql({
          query: `
              query{
                runQuery(consulta:"select * FROM CONTROL.permiso_compensacion  WHERE id_permiso=${this.permiso.id_permiso} "){
                  respuesta
                }
              }
            `
        });
        respuesta = respuesta.runQuery.respuesta;
        for (let index = 0; index < respuesta.length; index++) {
          const element = respuesta[index];
          element.total_horas = this.$moment(element.hora_hasta, "HH:mm")
            .subtract(element.hora_desde, "HH:mm")
            .format("HH:mm");
          this.total_horas_compensacion.add(element.total_horas);
          this.total_horas_resguardo.add(element.total_horas);
        }
        this.compensaciones = respuesta;
        this.compensaciones_resguardo = respuesta;
      } catch (error) {
        console.log(error);
      }
    },
    borrarCompensacionDetalle(id) {
      this.$confirm("¿Esta seguro de eliminar el registro?", () => {
        let posicion;
        let compensaciones_aux = [];
        for (let index = 0; index < this.compensaciones.length; index++) {
          const element = this.compensaciones[index];
          if (element.id != id) {
            compensaciones_aux.push(element);
          } else {
            this.total_horas_compensacion.subtract(element.total_horas);
          }
        }
        this.compensaciones = compensaciones_aux;
      });
    },
    async obtieneHorasCompensacion() {
      if (
        this.permiso.hora_desde &&
        this.permiso.hora_hasta &&
        this.permiso.fecha_desde
      ) {
        let respuesta = await this.$service.graphql({
          query: `
              query{
                runQuery(consulta:"select control.fn_calcula_diferencia_horas_funcionario(${this.getPersonaId()},'${
            this.permiso.hora_desde
          }','${this.permiso.hora_hasta}','${this.permiso.fecha_desde}')"){
                  respuesta
                }
              }
            `
        });
        respuesta =
          respuesta.runQuery.respuesta[0]
            .fn_calcula_diferencia_horas_funcionario;
        if (respuesta.split("|")[0] != "0") {
          this.debe_horas_compensacion = respuesta;
        }
      }
    },
    async verificaCompensacion() {
      try {
        this.hora_desde_calculada = "";
        this.hora_hasta_calculada = "";
        this.total_horas_calculad = "";
        if (
          this.form.fecha_desde &&
          this.form.tipo_dia &&
          this.form.horario &&
          this.form.horas_compensa &&
          this.permiso.fecha_desde &&
          this.permiso.hora_desde &&
          this.permiso.hora_hasta
        ) {
          let id_persona = this.getPersonaId();
          let respuesta = await this.$service.graphql({
            query: `
              query{
                runQuery(consulta:"select control.fn_obtine_rangos_compensacion_tolerancia(${id_persona},'${
              this.form.fecha_desde
            }',${parseInt(this.form.tipo_dia)},${parseInt(
              this.form.horario
            )},'${this.form.horas_compensa}','${this.permiso.fecha_desde}','${
              this.permiso.hora_desde
            }','${this.permiso.hora_hasta}')"){
                  respuesta
                }
              }
            `
          });
          respuesta =
            respuesta.runQuery.respuesta[0]
              .fn_obtine_rangos_compensacion_tolerancia;
          let horarios = respuesta.split("|");
          if (horarios[0] != "0") {
            this.hora_desde_calculada = horarios[1];
            this.hora_hasta_calculada = horarios[2];
            this.total_horas_calculada = horarios[3];
          } else {
            this.mensaje_error = horarios[1];
            this.$message.info(this.mensaje_error);
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    cargarCompensacion() {
      if (
        this.form.fecha_desde &&
        this.form.tipo_dia &&
        this.form.horario &&
        this.form.horas_compensa &&
        this.hora_desde_calculada &&
        this.hora_hasta_calculada &&
        this.total_horas_calculada
      ) {
        let compensacion_crear = {
          id: this.correlativo_compensacion,
          fecha_desde: this.form.fecha_desde,
          hora_desde: this.hora_desde_calculada,
          hora_hasta: this.hora_hasta_calculada,
          total_horas: this.total_horas_calculada
        };
        this.compensaciones.push(compensacion_crear);
        this.correlativo_compensacion += 1;
        this.form.fecha_desde = "";
        this.form.tipo_dia = "";
        this.form.horario = "";
        this.form.horas_compensa = "";
        this.hora_desde_calculada = "";
        this.hora_hasta_calculada = "";
        this.total_horas_calculada = "";
        this.$message.success("Registro exitoso");
        this.total_horas_compensacion.add(compensacion_crear.total_horas);
      } else {
        if (this.mensaje_error) {
          this.$message.warning(this.mensaje_error);
        } else {
          this.$message.warning("Revise si lleno todos los campos requeridos");
        }
      }
    },
    getPersonaId() {
      const user = this.$storage.get("user");
      return this.$route.params.id ? this.$route.params.id : user.id_persona;
    },
    getRuta() {
      let p = this.$route.path;
      const a = p.split("/");
      return a[3];
    },
    close() {
      this.permiso = {
        id_tipo_permiso: null,
        motivo: ""
      };
      this.bandera_file = false;
      this.total_horas_compensacion = this.$moment().set({
        hour: 0,
        minutes: 0,
        seconds: 0
      });
      this.edit = true;
      this.$bus.$emit("closeDialogModificarPermisoCompensacion");
      this.dialog = false;
    },
    async verificarPermisosRango(
      fecha_desde,
      fecha_hasta,
      hora_desde,
      hora_hasta,
      id_permiso
    ) {
      //Funcion notifica que hay un permiso creado en el rango de fechas seleccionado
      let existePermisos = false;
      let permisos = "¿Esta seguro guardar el permiso?";
      let permisos_consulta = "";
      let respuesta;
      try {
        respuesta = await this.$service.graphql({
          query: `
              query{
                runQuery(consulta:"select control.fn_permisos_por_funcionario_actualiza(${this.getPersonaId()},'${fecha_desde}','${fecha_hasta}','${hora_desde}','${hora_hasta}',${parseInt(
            id_permiso
          )})"){
                  respuesta
                }
              }
            `
        });
        respuesta =
          respuesta.runQuery.respuesta[0].fn_permisos_por_funcionario_actualiza;
        respuesta = respuesta.split("|");
        if (respuesta[0] == "1") {
          existePermisos = true;
          permisos_consulta +=
            "<br><strong>Usted tiene los siguientes permisos en las fechas u horarios solicitados:</strong><br>" +
            respuesta[1].replace(/#/g, "<br>");
        }
      } catch (error) {
        console.log(error);
      }

      if (existePermisos) {
        this.$alert("No puede crear el permiso" + permisos_consulta);
      }
      return [existePermisos, permisos + permisos_consulta];
    },
    async verificarRangoMediaHora(bandera_mensaje) {
      try {
        if (this.permiso.hora_desde && this.permiso.hora_hasta) {
          let respuesta = await this.$service.graphql({
            query: `
              query{
                runQuery(consulta:"select control.fn_valida_rangos_media_hora('${this.permiso.hora_desde}','${this.permiso.hora_hasta}')"){
                  respuesta
                }
              }
            `
          });
          respuesta =
            respuesta.runQuery.respuesta[0].fn_valida_rangos_media_hora;
          respuesta = respuesta.split("|");
          if (respuesta[0] == "1") {
            this.bandera_media_hora = true;
            return true;
          } else {
            if (bandera_mensaje) {
              this.$message.info(respuesta[1]);
            }
            this.bandera_media_hora = false;
            return false;
          }
        }
      } catch (error) {}
    },
    //verifica que una vacacion aprobada no choque con el permiso:
    async verificaVacaciones(fecha_desde, fecha_hasta) {
      let existe_vacacion = false;
      let permisos_consulta = "";
      let respuesta;
      try {
        respuesta = await this.$service.graphql({
          query: `
              query{
                runQuery(consulta:"select vacaciones.fn_verifica_coincidencia_de_vacaciones_aprobadas(${this.getPersonaId()},'${fecha_desde}','${fecha_hasta}')"){
                  respuesta
                }
              }
            `
        });
        respuesta =
          respuesta.runQuery.respuesta[0]
            .fn_verifica_coincidencia_de_vacaciones_aprobadas;

        if (respuesta != "0") {
          existe_vacacion = true;
          permisos_consulta +=
            "<br><strong>Usted tiene la siguiente vacación aprobada en las fechas solicitadas:</strong><br>" +
            respuesta.replace(/#/g, "<br>");
          this.$message.warning(permisos_consulta);
        }
        return existe_vacacion;
      } catch (error) {
        console.log(error);
      }
    },
    async save() {
      let rango_30_minutos = await this.verificarRangoMediaHora(true);
      if (rango_30_minutos == true) {
        //consulta si existe una vacacion aprobada en ese rango de fechas
        let verifica_vacacion = await this.verificaVacaciones(
          this.permiso.fecha_desde,
          this.permiso.fecha_desde
        );
        if (verifica_vacacion == true) {
          return;
        }
        //consulta si existe un permiso aprobado en ese rango de fechas
        let consulta = await this.verificarPermisosRango(
          this.permiso.fecha_desde,
          this.permiso.fecha_desde,
          this.permiso.hora_desde,
          this.permiso.hora_hasta,
          this.permiso.id_permiso
        );
        if (consulta[0] == true) {
          return;
        }
        this.$confirm(consulta[1], async () => {
          let mensaje_error_exito;
          // Archivos no obligatorios
          if (
            (this.ruta_a == "" && this.file) ||
            (this.ruta_a != "" && this.file)
          ) {
            if (this.errors.denied) {
              return this.errors;
            }
          }
          let ruta_ar = "";
          //Cargar ruta del archivo
          if (
            (this.ruta_a == "" && this.file) ||
            (this.ruta_a != "" && this.file)
          ) {
            if (this.$refs.file.value !== "") {
              let formData = new FormData();
              formData.append("file", this.file);
              let res = await this.$http.post(
                process.env.API_URL + "public/upload",
                formData
              );
              ruta_ar = res.data;
            }
          } else {
            if (this.permiso.permiso.ruta_archivo != "") {
              ruta_ar = this.permiso.permiso.ruta_archivo;
            } else {
              ruta_ar = "";
            }
          }

          if (this.radio_data == 0) {
            let correcto;
            let resps;
            try {
              let user = this.$storage.get("user");
              let id_permiso_creado = parseInt(this.permiso.id_permiso);
              //eliminando compensaciones si tiene
              respuesta = await this.$service.graphql({
                query: `
            query{
              runQuery(consulta:"select control.fn_elimina_compensacion_por_permiso(${id_permiso_creado})"){
                    respuesta
                }
              }
            `
              });
              //actualiza el permiso

              let fecha_actual = this.$moment().format("YYYY-MM-DD");
              this.permiso.motivo = this.permiso.motivo.replace(
                /(\r\n|\n|\r)/gm,
                " "
              );
              this.permiso.motivo = this.permiso.motivo.replace(/"/g, "`");
              let respuesta = await this.$service.graphql({
                query: `
                                                query{
                                                  runQuery(consulta:"select control.fn_actualiza_tolerancia(${parseInt(
                                                    this.permiso.id_permiso
                                                  )},'${fecha_actual}',${
                  user.id
                },'${this.permiso.fecha_desde}','${
                  this.permiso.fecha_desde
                }','${this.permiso.hora_desde}','${this.permiso.hora_hasta}','${
                  this.permiso.motivo
                }',${parseInt(this.radio_data)},'${ruta_ar}',${parseInt(
                  this.permiso.rol
                )})"){
                                                    respuesta
                                                  }
                                                }	
                                              `
              });
              //

              this.bandera_file = false;
              respuesta =
                respuesta.runQuery.respuesta[0].fn_actualiza_tolerancia;
              resps = respuesta.split("|");
              correcto = resps[0] == 1;
              if (correcto == "1") {
                //"Modificación exitosa"
                this.$alert("Modificación exitosa", () => {
                  this.close();
                });
              } else {
                if (resps[2] == "Fecha Inicio Menor a Fecha Permiso") {
                  resps[1] = resps[2];
                }
                this.$alert(resps[1]);
              }
            } catch (error) {
              console.log(error);
            }
          } else {
            if (
              this.$moment(this.total_horas_compensacion, "HH:mm").format(
                "HH:mm"
              ) ==
              this.$moment(this.debe_horas_compensacion, "HH:mm").format(
                "HH:mm"
              )
            ) {
              let resps;
              let respuesta;
              let correcto;
              resps = [];
              let user = this.$storage.get("user");
              let id_permiso_creado = this.permiso.id_permiso;
              let fecha_actual = this.$moment().format("YYYY-MM-DD");

              try {
                this.permiso.motivo = this.permiso.motivo.replace(
                  /(\r\n|\n|\r)/gm,
                  " "
                );
                this.permiso.motivo = this.permiso.motivo.replace(/"/g, "`");
                respuesta = await this.$service.graphql({
                  query: `
              query{
                runQuery(consulta:"select control.fn_actualiza_tolerancia(${id_permiso_creado},'${fecha_actual}',${
                    user.id
                  },'${this.permiso.fecha_desde}','${
                    this.permiso.fecha_desde
                  }','${this.permiso.hora_desde}','${
                    this.permiso.hora_hasta
                  }','${this.permiso.motivo}',${parseInt(
                    this.radio_data
                  )},'${ruta_ar}',${parseInt(this.permiso.rol)})"){
                      respuesta
                  }
                }
              `
                });
                let respuesta2 =
                  respuesta.runQuery.respuesta[0].fn_actualiza_tolerancia;
                resps = respuesta2.split("|");
                correcto = resps[0];

                if (resps[0] == 1) {
                  //Borrando compensaciones
                  try {
                    respuesta = await this.$service.graphql({
                      query: `
                        query{
                          runQuery(consulta:"select control.fn_elimina_compensacion_por_permiso(${id_permiso_creado})"){
                                respuesta
                            }
                          }
                        `
                    });
                    let respuesta2 =
                      respuesta.runQuery.respuesta[0]
                        .fn_elimina_compensacion_por_permiso;
                    resps = respuesta2.split("|");
                    correcto = resps[0];
                  } catch (error) {
                    console.log(error);
                  }
                  try {
                    // Guarda compensaciones
                    let esCorrecto = true;
                    for (
                      let index = 0;
                      index < this.compensaciones.length;
                      index++
                    ) {
                      const element = this.compensaciones[index];
                      let respuesta_comp = await this.$service.graphql({
                        query: `
                  query{
                      runQuery(consulta:"select control.fn_registra_compensacion_y_o_elimina(${id_permiso_creado},'${element.fecha_desde}','${element.fecha_desde}','${element.hora_desde}','${element.hora_hasta}',${user.id})"){
                          respuesta
                      }
                    }
                  `
                      });
                      let respuesta3 =
                        respuesta_comp.runQuery.respuesta[0]
                          .fn_registra_compensacion_y_o_elimina;
                      resps = respuesta3.split("|");
                      //validacion del permiso correcto

                      if (resps[0] == "0") {
                        this.$alert(resps[1]);
                        esCorrecto = false;
                        break;
                      }
                    }
                    if (esCorrecto) {
                      this.$alert("Modificación exitosa", () => {
                        this.close();
                      });
                    }
                  } catch (error) {
                    console.log(error);
                  }
                } else {
                  this.$alert(resps[1], () => {});
                }
              } catch (error) {
                console.log(error);
              }
            } else {
              this.$alert(
                "Las horas de compensación no son iguales a las horas solicitadas"
              );
            }
          }
        });
      } else {
        this.$alert("Los intervalos de horas deben de ser de 30 minutos");
      }
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/permiso/dialogs/ModificarPermisoToleranciaCompensacion.vue